<template>
  <el-dialog
    title="商家防伪扣发放"
    :visible.sync="visible"
    width="360px"
    append-to-body
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="90px">
      <el-form-item label="商家名称:">{{ ruleForm.vendorName }}</el-form-item>
      <el-form-item label="商家防伪扣类型:">{{ ruleForm.appraisalType === 1 ? '鉴定意见书' : '商家防伪扣' }}</el-form-item>
      <el-form-item label="申请数量:">{{ ruleForm.applyCount }}个</el-form-item>
      <el-form-item
        label="发放数量:"
        prop="provideCount">
        <el-input-number
          v-model="ruleForm.provideCount"
          style="width: 100%"
          :precision="0"
          :min="1"
          :max="ruleForm.applyCount"></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'ProvideTagModal',
  props: {
    callback: { type: Function }
  },
  data() {
    return {
      loading: false,
      visible: false,
      ruleForm: { id: null, vendorName: '', applyCount: 0, appraisalType: null, provideCount: 0 },
      rules: {
        provideCount: [
          { required: true, message: '请输入发放数量', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleClose() {
      this.$set(this, 'ruleForm', { id: null, vendorName: '', applyCount: 0, appraisalType: null, provideCount: 0 })
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$confirm(`发放数量为${this.ruleForm.provideCount}个, 是否继续?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true
            this.$store.dispatch('appraise/appraisaltagprovide', {
              payload: this.ruleForm,
              success: () => {
                this.loading = false
                this.visible = false
                this.$message.success('发放成功')
                this.callback && this.callback()
              },
              fail: () => {
                this.loading = false
              }
            })
          })
        }
      })
    },
    init(options = {}) {
      this.ruleForm = { ...this.ruleForm, ...options }
      this.visible = true
    }
  }
}
</script>
